import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import makeStyles from '@mui/styles/makeStyles';
import { FormattedMessage } from 'react-intl';
import { useSelector } from 'react-redux';
import { Feature, Subscription } from '../../models';
import { fromAccounts, fromAuth, fromSubscription, useAppDispatch } from '../../store';
import { Page } from '../../components/page';
import ButtonToLicenseManagement from '../payment-status/ButtonToLicenseManagement';
import { TrueEnterprise } from './component/true-platform/TrueEnterprise';
import { TrueSubscription } from './component/true-platform/TrueSubscription';
import { TruePlatformWelcome } from './component/true-platform/TruePlatformWelcome';

const useStyles = makeStyles(theme => ({
  sectionHeader: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: theme.spacing(2),
  },
  sectionTitle: {
    fontWeight: 600,
    fontSize: 20,
    color: '#22283C',
  },
  contentGrid: {
    display: 'flex',
    flexDirection: 'row',
    gap: theme.spacing(3),
    alignItems: 'flex-start',
    [theme.breakpoints.down('tablet')]: {
      flexDirection: 'column',
    },
  },
}));

const SubscriptionV2Content = (
  { trueSubscription }: { trueSubscription?: Subscription },
) => {
  const classes = useStyles();
  const isEnterprise = trueSubscription?.feature === Feature.TRUE_ENTERPRISE;

  if (!trueSubscription) {
    return null;
  }

  return (
    <Box paddingY={2}>
      <Box className={classes.sectionHeader}>
        <Typography className={classes.sectionTitle}>
          <FormattedMessage id="page.subscription.current.subscription.title" />
        </Typography>
        <ButtonToLicenseManagement
          title="page.subscription.manage.license.button"
          width={300}
          height={50}
          fontWeight={700}
          marginRight={1}
        />
      </Box>

      <Box className={classes.contentGrid}>
        {/* Main subscription card */}
        <TrueSubscription
          trueSubscription={trueSubscription}
        />

        {/* True Enterprise upsell panel (hidden when user has True Enterprise) */}
        {!isEnterprise && (
          <TrueEnterprise />
        )}
      </Box>
    </Box>
  );
};

export const SubscriptionV2 = (
  { subscription, accountId }: { subscription: Subscription; accountId: number },
) => {
  const dispatch = useAppDispatch();
  const user = useSelector(fromAuth.selectUser);
  const upgradeToTrue = useSelector(fromSubscription.selectUpgradeToTrue);

  const fetchResource = async () => {
    if (accountId) {
      await Promise.all([
        dispatch(fromAccounts.doGetSalesforceLinkedAccount()),
      ]);
    }
  };

  return (
    <Page
      id="subscription"
      headerId="page.subscription.header"
      headerValue={{ userName: user?.firstName }}
      fetchData={fetchResource}
    >
      {upgradeToTrue && (
        <Box mt={2}>
          <TruePlatformWelcome />
        </Box>
      )}
      <SubscriptionV2Content trueSubscription={subscription} />
    </Page>
  );
};
